<div class="operations-details-table">
  <div class="operations-details-table-title-container">
    <fw-icon size="small" [color]="iconColor">{{ icon }}</fw-icon>
    <span class="operations-details-table-title">
      {{title}}
    </span>
  </div>
  <div class="operations-details-table-body">
    <div *ngFor="let row of tableConfig" class="operations-details-table-body-row"
      [ngClass]="{small: isSmall, danger: row.isDanger, warning: row.isWarning}">
      <span>{{row.title | translate}}</span>
      <span>{{isShowCount(row.count) ? row.count : 'operationDetailsTable.noData' | translate}}</span>
    </div>
    <div *ngIf="isWithTotal" class="operations-details-table-body-row total" [class.small]=isSmall>
      <span>{{ 'operationDetailsTable.total' | translate }}</span>
      <span>{{total}}</span>
    </div>
  </div>
</div>
